import React from "react";
import "./BestWebLogo.css";

const BestWebLogo = () => {

    return (
      <div>
        <a
          href="https://ebadge.bestweb.lk/api/v1/clicked/cic.lk/BestWeb/2025/Rate_Us"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Rate us on BestWeb 2025"
          className="bestweb-center"
        >
          <img
            src="https://ebadge.bestweb.lk/eBadgeSystem/domainNames/cic.lk/BestWeb/2025/Rate_Us/image.png"
            className="bestweb"
            alt="BestWeb 2025 Rate Us"
            width="150"
            height="150"
          />
        </a>
      </div>
    )
};

export default BestWebLogo;
